export default "__VITE_ASSET__Bn2sFs45__"